import React from "react";
import { Button, ButtonProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomButton = styled(Button)({
  borderRadius: "6px",
  padding: "10px 20px",
  height: "40px",
  userSelect: "none",
  verticalAlign: "middle",
  textDecoration: "none",
  fontFamily: `Inter, sans-serif`,
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "120%",
  letterSpacing: "-1px",
  fontSize: "18px",
  textTransform: "none",
  minWidth: "64px",
});

interface OutlinedButtonProps extends ButtonProps {
  children: React.ReactNode;
}

const OutlinedButton: React.FC<OutlinedButtonProps> = (props) => {
  return (
    <CustomButton variant="outlined" {...props}>
      {props.children}
    </CustomButton>
  );
};

export default OutlinedButton;
